import projects from './_projects.json';
import users from './_users.json';
import businesses from './businesses.json';

export default {
  _projects: projects,
  _users: users,
  businesses: businesses,
};